import { useTranslation } from "react-i18next";
import { Pressable } from "react-native";
import { Caption, Text } from "react-native-paper";

import { useAppTheme } from "@hooks/useAppTheme";

import type { OriginalStimulusTypes } from "@memorang/types/src/session/new-session";
import Box from "@memorang/ui/src/components/Box";
import Button from "@memorang/ui/src/components/Button";
import AudioPlayerContainer from "../containers/AudioPlayerContainer";

type CtaInfo = { text: string; icon: string };

export const PassageStem = ({
	parentStem,
	parentAudio,
	toggleShowReadMore,
	index,
	numPassageItems,
	parentTitle,
	parentType,
	itemId,
}: {
	parentStem?: string;
	numPassageItems?: number;
	inReviewMode?: boolean;
	toggleShowReadMore?: () => void;
	index?: number;
	parentAudio?: string;
	parentTitle?: string;
	parentType: OriginalStimulusTypes;
	itemId: number;
}) => {
	const theme = useAppTheme();
	const { t } = useTranslation();

	const getCtaInfo = (): CtaInfo => {
		switch (parentType) {
			case "READING":
				return {
					text: t("session.passageStem.passage"),
					icon: "book-open-page-variant-outline",
				};
			case "LISTENING":
				return {
					text: t("session.passageStem.lecture"),
					icon: "book-open-page-variant-outline",
				};
			case "ACADEMIC_DISCUSSION_STIMULUS":
				return {
					text: t("session.passageStem.professorsQuestion"),
					icon: "book-open-page-variant-outline",
				};
			case "INTEGRATED_WRITING_STIMULUS":
				return {
					text: t("session.passageStem.lecture"),
					icon: "book-open-page-variant-outline",
				};
			case "LS_STIMULUS":
			case "RLS_STIMULUS":
			case "INDEPENDENT_SPEAKING_STIMULUS":
				return { text: t("session.passageStem.listen"), icon: "headphones" };
			default:
				return {
					text: t("session.passageStem.passage"),
					icon: "page-next-outline",
				};
		}
	};

	const { text: cta, icon } = getCtaInfo();

	return (
		<Box>
			<Box
				backgroundColor={theme.colors.surface}
				borderBottomWidth={1}
				borderBottomColor={theme.colors.divider}
			>
				{parentAudio && (
					<AudioPlayerContainer uri={parentAudio} itemId={itemId} />
				)}
				{parentStem || parentTitle ? (
					<Pressable onPress={toggleShowReadMore}>
						<Box
							flexDirection="row"
							justifyContent="space-between"
							alignItems="center"
							paddingBottom={16}
						>
							<Box paddingHorizontal={16} flex={1}>
								<Text variant="titleMedium" numberOfLines={1}>
									{parentTitle}
								</Text>
								<Caption>
									{t("session.passageStem.item")} {index}{" "}
									{t("session.passageStem.of")} {numPassageItems}
								</Caption>
							</Box>
							<Button icon={icon} mode="text" onPress={toggleShowReadMore}>
								{cta}
							</Button>
						</Box>
					</Pressable>
				) : null}
			</Box>
		</Box>
	);
};
